import React, { Component } from 'react';
import { Button, Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PasswordFormField } from '../components';
import { validatePassword } from '../../services';
import { userActions } from '../../state/modules/user';
import logo from '../../images/logo_rev.svg';

/**
 * Responsible for password reset form and actions.
 */
class ResetPassword extends Component {

  constructor() {
    super();

    this.state = {
      password: {
        value: '',
        isValid: true
      },
      confirmPassword: {
        value: '',
        isValid: true
      }
    };
  }

  resetPassword(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.validateForm()) {
      this.props.resetPassword({ credentials: { password: this.state.password.value } });
    }
  }

  validateForm() {
    const passwordValid = validatePassword(this.state.password.value);
    const confirmPasswordValid = validatePassword(this.state.confirmPassword.value)
      && this.state.password.value === this.state.confirmPassword.value;

    this.setState({
      password: Object.assign({}, this.state.password, { isValid: passwordValid }),
      confirmPassword: Object.assign({}, this.state.confirmPassword, { isValid: confirmPasswordValid })
    });

    return passwordValid && confirmPasswordValid;
  }

  loginFormItem(id, label) {
    const passwordProps = {
      id,
      label,
      value: this.state[id].value,
      onChange: (e) => this.setState({ [id]: Object.assign({}, this.state[id], { value: e.target.value }) })
    };

    return <PasswordFormField {...passwordProps} />;
  }

  render() {
    return (
      <div className='login'>
        <Grid>
          <form noValidate onSubmit={(e) => this.resetPassword(e)}>
            <header>
              <img src={logo} alt='Caddie Platform' />
              <p>Reset password</p>
            </header>
            <main>
              <p>Please enter a new password below:</p>
              {this.loginFormItem('password', 'Enter a new password')}
              {this.loginFormItem('confirmPassword', 'Confirm new password')}
            </main>
            <footer>
              <Button type='submit' className='large'>Reset password</Button>
            </footer>
          </form>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: bindActionCreators(userActions.user.resetPassword, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/pages/reset-password.js